export const formatPageNumbers = (pageNumbers: number[] | null | undefined): string => {
  if (!pageNumbers || pageNumbers.length === 0) return '';
  if (pageNumbers.length === 1) return `Page ${pageNumbers[0]}`;
  return `Pages ${pageNumbers.join(', ')}`;
};

export const formatMeetingDateTime = (dateStr: string): string => {
  const normalized = dateStr.endsWith('Z') ? dateStr : dateStr + 'Z';
  return new Date(normalized).toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
};
